import React from 'react';

const SentenceColumn = ({ sentences, hoveredIndex, onMouseEnter, onMouseLeave, isLeft }) => {
  return (
    <div className="sentence-column">
      {sentences.map((sentence, idx) => (
        <div
          key={`${isLeft ? 'left' : 'right'}-${idx}`}
          className={`sentence-item ${hoveredIndex === idx ? 'highlight' : ''}`}
          onMouseEnter={() => onMouseEnter(idx, isLeft ? sentence[0] : sentence[1])}
          onMouseLeave={onMouseLeave}
        >
          {isLeft ? sentence[0] : sentence[1]}
        </div>
      ))}
    </div>
  );
};

export default SentenceColumn;